import type { ToolCategory } from '../types/tools';

export interface CategoryConfig {
  key: ToolCategory;
  label: string;
}

/** Ordem e labels das categorias no menu de ferramentas */
export const CATEGORY_CONFIG: CategoryConfig[] = [
  { key: 'nesting', label: 'Montagem' },
  { key: 'transform', label: 'Transformacao' },
  { key: 'measure', label: 'Medicao' },
  { key: 'effects', label: 'Efeitos' },
  { key: 'export', label: 'Exportacao' },
  { key: 'commercial', label: 'Comercial' },
  { key: 'create', label: 'Criacao' },
  { key: 'utility', label: 'Utilitarios' },
];
